import Vue from "vue";
import Router from "vue-router";
import login from "@/components/Views/LoginPage.vue";
import makeBooking from "@/components/Views/MakeBooking.vue";
import manageBooking from "@/components/Views/ManageBooking.vue";
import case_credit_calculator from "@/components/Views/case_credit_calculator.vue";
import home_page from "@/components/Views/home_page.vue";
import notice_page from "@/components/Views/notice_page.vue";
import notice_display from "@/components/Views/notice_dispaly.vue";
import web_tips from "@/components/Views/web_tips.vue";
import reward_program from "@/components/Views/reward_program.vue";
import faq_page from "@/components/Views/faq_page.vue";
import source_download from "@/components/Views/source_download_page.vue";
import form_download from "@/components/Views/form_download_page.vue";

Vue.use(Router);

// defind page location
const routes = [
  {
    path: "/",
    name: "home",
    meta: {
      title: "Forever Living FBO資訊平台",
      appTitle: "Forever Living FBO資訊平台",
    },
    component: home_page,
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登入尖沙咀及元朗會議室預約系統",
      appTitle: "登入尖沙咀及元朗會議室預約系統",
    },
    component: login,
  },
  {
    path: "/makeBooking",
    name: "makeBooking",
    meta: {
      title: "預約房間",
      appTitle: "預約房間",
    },
    component: makeBooking,
  },
  {
    path: "/manageBooking",
    name: "manageBooking",
    meta: {
      title: "管理預約",
      appTitle: "管理預約",
    },
    component: manageBooking,
  },
  {
    path: "/case_credit_calculator",
    name: "case_credit_calculator",
    meta: {
      title: "箱積分計算機",
      appTitle: "箱積分計算機",
    },
    component: case_credit_calculator,
  },
  {
    path: "/notice",
    name: "notice_page",
    meta: {
      title: "Forever Living最新消息",
      appTitle: "Forever Living最新消息",
    },
    component: notice_page,
  },
  {
    path: "/notice/:id",
    name: "notice_display",
    meta: {
      title: "Forever Living最新消息",
      appTitle: "Forever Living最新消息",
    },
    component: notice_display,
    props: true,
  },
  {
    path: "/web_tips",
    name: "web_tips",
    meta: {
      title: "每月小提示",
      appTitle: "每月小提示",
    },
    component: web_tips,
  },
  {
    path: "/reward_program",
    name: "reward_program",
    meta: {
      title: "消費獎賞查詢",
      appTitle: "消費獎賞查詢",
    },
    component: reward_program,
  },
  {
    path: "/faq",
    name: "faq",
    meta: {
      title: "Forever Living 常見問題",
      appTitle: "Forever Living 常見問題",
    },
    component: faq_page,
  },
  {
    path: "/source_download",
    name: "source_download",
    meta: {
      title: "Forever Living 資源下載",
      appTitle: "Forever Living 資源下載",
    },
    component: source_download,
  },
  {
    path: "/form_download",
    name: "form_download",
    meta: {
      title: "Forever Living 表格下載",
      appTitle: "Forever Living 表格下載",
    },
    component: form_download,
  },
];

// defind router mode
const router = new Router({
  mode: "history",
  routes,
});

// before every page trandfer
router.beforeEach((to, from, next) => {
  // set page title
  document.title = to.meta.title || "Forever Living Hong Kong";

  // set apple web app title
  const apple_meta = document.querySelector(
    'meta[name="apple-mobile-web-app-title"]',
  );
  if (apple_meta) {
    apple_meta.setAttribute("content", to.meta.appTitle);
  } else {
    const new_apple_meta = document.createElement("meta");
    new_apple_meta.setAttribute("name", "apple-mobile-web-app-title");
    new_apple_meta.setAttribute(
      "content",
      to.meta.appTitle || "Forever Living",
    );
    document.head.appendChild(new_apple_meta);
  }

  next();
});

// for google analytics
// eslint-disable-next-line
router.afterEach((to, from) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_title: to.meta.title || to.name,
      page_path: to.fullPath,
      page_location: window.location.href,
    });
    console.log("GA4 page_view sent:", to.fullPath);
  }
});

export default router;
